import { MprcFilterBox } from 'components/filter';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { MprcSearchTextFieldConfirmMode } from 'components/MprcSearchTextField';
import { CatalogSetupResponse, CoreFilterCommand } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AdvancedFilter } from 'views/general/AdvancedFilter';
import { IAdvFilterCommand, IAdvFilterDropdown } from 'views/general/AdvancedFilter/interfaces';
import { ICatalogFilterOptions } from 'views/lms/student/Catalog/FilterCommon';
import { courseTypeMenuOptions, orderMenuOptions, otherMenuOptions, periodMenuOptions, stickersMenuOptions, topicMenuOptions, workloadMenuOptions } from 'views/lms/student/Catalog/FilterMenus';

/////////////////////////////////////////////////////////////////////////////

interface IRenderFilterProps {
    viewFilter: ICatalogFilterOptions;
    setViewFilter: (filter: ICatalogFilterOptions) => void;
    searchTextConfirmMode?: MprcSearchTextFieldConfirmMode;
}

export const CatalogFilter = ({ viewFilter, setViewFilter, searchTextConfirmMode }: IRenderFilterProps) => {
    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const [loading, setLoading] = useState<boolean>(true);
    const [catalogSetup, setCatalogSetup] = useState<CatalogSetupResponse | null>(null);

    ///
    const getLeftDropdownOptions = useMemo(() => {
        const stickerCommands: IAdvFilterCommand[] = catalogSetup?.stickers.map(sticker => {
            const cmd: IAdvFilterCommand = {
                command: CoreFilterCommand.TrainingSticker,
                displayName: sticker.name,
                canRepeat: true,
                group: 1,
                fixedValue: sticker.stickerId,
                canCheck: true
            };
            return cmd;
        }) ?? [];

        return [
            topicMenuOptions(t),
            courseTypeMenuOptions(t),
            stickersMenuOptions(t, stickerCommands, loading),
            periodMenuOptions(t),
            workloadMenuOptions(t),
            otherMenuOptions(t, catalogSetup?.isManager ?? false)
        ].filter(item => item != null) as IAdvFilterDropdown[];
    }, [t, catalogSetup]);

    /// Obtem parãmetros iniciais para montagem do menu de opções.
    useEffect(() => {
        async function getData() {
            try {
                const result = await api.v1.lmsStudent.getCatalogSetup({});
                setCatalogSetup(result.data);
            } catch (e) {
                MprcRequestSnackbarErrorReport(e);
            }
            finally {
                setLoading(false);
            }
        }
        getData();
    }, []);

    return <MprcFilterBox>
        <AdvancedFilter
            filter={viewFilter}
            orderMenuOptions={orderMenuOptions(t)}
            leftDropdowns={getLeftDropdownOptions}
            searchTextConfirmMode={searchTextConfirmMode}
            onFilterChange={setViewFilter}
            onError={MprcRequestSnackbarErrorReport}
        />
    </MprcFilterBox>;
};
